'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";
import {PDFDocument} from 'pdf-lib';
import html2canvas from 'html2canvas';

EwSiteApp.factory('pdfService', function () {
    return {
        generatePDF: async function (contentSelector, fileTitle) {
            // Select tab contents and save original styles
            const tabContents = document.querySelectorAll('md-tab-content.md-right:not(.md-active), md-tab-content.md-right:not(.md-active) *');
            const originalStyles = [];
            tabContents.forEach((element, index) => {
                const computedStyle = window.getComputedStyle(element);
                originalStyles[index] = {
                    transform: computedStyle.transform,
                    visibility: computedStyle.visibility,
                    position: computedStyle.position,
                    transition: computedStyle.transition,
                };

                element.style.transform = 'none';
                element.style.visibility = 'visible';
                element.style.position = 'relative';
                element.style.transition = 'none';
            });

            try {
                const content = document.querySelector(contentSelector);
                const canvas = await html2canvas(content, {
                    scale: 2,
                    scrollY: 0,
                    useCORS: true,
                    ignoreElements: function (element) {
                        return element.classList.contains('pdf-ignore') || element.classList.contains('print-wrapper');
                    },
                });

                const imgWidth = 900;
                const imgHeight = canvas.height * imgWidth / canvas.width;
                const pageHeight = 1201;
                const margin = tabContents.length ? 7 : 11;
                const pdfDoc = await PDFDocument.create();
                let position = 0;

                while (position < imgHeight) {
                    const sliceHeight = Math.min(imgHeight - position, pageHeight - margin * 2);

                    const canvasSlice = document.createElement('canvas');
                    canvasSlice.width = canvas.width;
                    canvasSlice.height = sliceHeight * canvas.width / imgWidth;

                    const ctx = canvasSlice.getContext('2d');
                    ctx.drawImage(
                        canvas,
                        0, position * canvas.width / imgWidth,
                        canvas.width, sliceHeight * canvas.width / imgWidth,
                        0, 0,
                        canvasSlice.width, canvasSlice.height
                    );

                    const sliceImg = canvasSlice.toDataURL('image/png');
                    const sliceImage = await pdfDoc.embedPng(sliceImg);

                    const page = pdfDoc.addPage([imgWidth, pageHeight]);
                    page.drawImage(sliceImage, {
                        x: margin,
                        y: pageHeight - sliceHeight - margin,
                        width: imgWidth - margin * 2,
                        height: sliceHeight,
                    });

                    position += sliceHeight;
                }

                const pdfBytes = await pdfDoc.save();
                const blob = new Blob([pdfBytes], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = `${fileTitle}.pdf`;
                link.click();
            } finally {
                tabContents.forEach((element, index) => {
                    element.style.transform = originalStyles[index].transform;
                    element.style.visibility = originalStyles[index].visibility;
                    element.style.position = originalStyles[index].position;
                    element.style.transition = originalStyles[index].transition;
                });
                location.reload();
            }
        },
    };
});
